/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ErrorModel,
    ErrorModelFromJSON,
    ErrorModelFromJSONTyped,
    ErrorModelToJSON,
} from './ErrorModel';
import {
    LoginResponseModel,
    LoginResponseModelFromJSON,
    LoginResponseModelFromJSONTyped,
    LoginResponseModelToJSON,
} from './LoginResponseModel';

/**
 * 
 * @export
 * @interface LoginResponseModelValidatedModel
 */
export interface LoginResponseModelValidatedModel {
    /**
     * 
     * @type {ErrorModel}
     * @memberof LoginResponseModelValidatedModel
     */
    error?: ErrorModel;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponseModelValidatedModel
     */
    readonly success?: boolean;
    /**
     * 
     * @type {LoginResponseModel}
     * @memberof LoginResponseModelValidatedModel
     */
    data?: LoginResponseModel;
}

export function LoginResponseModelValidatedModelFromJSON(json: any): LoginResponseModelValidatedModel {
    return LoginResponseModelValidatedModelFromJSONTyped(json, false);
}

export function LoginResponseModelValidatedModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponseModelValidatedModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': !exists(json, 'error') ? undefined : ErrorModelFromJSON(json['error']),
        'success': !exists(json, 'success') ? undefined : json['success'],
        'data': !exists(json, 'data') ? undefined : LoginResponseModelFromJSON(json['data']),
    };
}

export function LoginResponseModelValidatedModelToJSON(value?: LoginResponseModelValidatedModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': ErrorModelToJSON(value.error),
        'data': LoginResponseModelToJSON(value.data),
    };
}

